/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IIndexedNode } from '../../../core/models/IIndexedNode';
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';

/**
 * Constructor.
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export class Oas20ParameterDefinitions extends Node implements IIndexedNode<Oas20ParameterDefinition> {
    public items : any;

    public constructor() {
        super();
        this.items = <any>({});
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitParameterDefinitions(this);
    }

    /**
     * Returns a single parameter by name.
     * @param {string} name
     * @return {Oas20ParameterDefinition}
     */
    public getParameter(name : string) : Oas20ParameterDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, name);
    }

    /**
     * Returns an array of all the parameters.
     * @return {Oas20ParameterDefinition[]}
     */
    public getParameters() : Array<Oas20ParameterDefinition> {
        let rval : Array<Oas20ParameterDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        return rval;
    }

    /**
     * Adds a parameter.
     * @param {string} name
     * @param {Oas20ParameterDefinition} parameter
     * @return {Oas20ParameterDefinition}
     */
    public addParameter(name : string, parameter : Oas20ParameterDefinition) : Oas20ParameterDefinition {
        /* put */(this.items[name] = parameter);
        return parameter;
    }

    /**
     * Removes a parameter by name.
     * @param {string} name
     * @return {Oas20ParameterDefinition}
     */
    public removeParameter(name : string) : Oas20ParameterDefinition {
        return /* remove */(map => { let deleted = this.items[name];delete this.items[name];return deleted;})(this.items);
    }

    /**
     * Gets a list of all the parameter names.
     * @return {string[]}
     */
    public getParameterNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Creates an OAS 2.0 Parameter object.
     * @param {string} name
     * @return {Oas20ParameterDefinition}
     */
    public createParameter(name : string) : Oas20ParameterDefinition {
        let rval : Oas20ParameterDefinition = new Oas20ParameterDefinition(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {Oas20ParameterDefinition}
     */
    public getItem(name : string) : Oas20ParameterDefinition {
        return this.getParameter(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {Oas20ParameterDefinition[]}
     */
    public getItems() : Array<Oas20ParameterDefinition> {
        return this.getParameters();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getParameterNames();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20ParameterDefinition(name : string, item : Oas20ParameterDefinition) {
        this.addParameter(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {Oas20ParameterDefinition} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>Oas20ParameterDefinition) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20ParameterDefinition(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {Oas20ParameterDefinition}
     */
    public deleteItem(name : string) : Oas20ParameterDefinition {
        return this.removeParameter(name);
    }
}
Oas20ParameterDefinitions["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions";
Oas20ParameterDefinitions["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas20ParameterDefinition } from './Oas20ParameterDefinition';

